// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"src_bootstrap_tsx-webpack_sharing_consume_default_react-dom_react-dom":"163e35b8","src_pages_home_index_tsx-node_modules_swiper_modules_autoplay_autoplay_min_css-node_modules_s-f37065":"9f06063e"}[chunkId] + ".chunk.css";
};